module.exports = __webpack_public_path__ + "img/hrc-about.44fa8f62.jpg";